<template>
  <div class="SchoolReserveRecord">
    <ReserveRecord :props-data="{subscribeType: 1, getCode}" />
  </div>
</template>

<script>
import ReserveRecord from '@/views/systemMaintenance/common/reserveRecord.vue';
export default {
  name: 'SchoolReserveRecord',
  components: {
    ReserveRecord
  },
  data() {
    return {
      getCode: ''
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.getCode = route.query && route.query.getCode;
      },
      immediate: true
    }
  }
};
</script>
